import axios from 'axios'
import config from '@/configs/defaultConfigs'
import store from '@/store'
import { Message, Notice } from 'view-ui-plus';
import router from '../router'
// 创建一个 axios 实例
const service = axios.create({
	baseURL: process.env.VUE_APP_APIS_HOST , // config.baseURL '/api'所有的请求地址前缀部分
	timeout: 60000, // 请求超时时间毫秒
	headers: {
		// 设置后端需要的传参类型
		'Content-Type': 'application/json',
		'X-Requested-With': 'XMLHttpRequest',
		'Authorization': '',
	},
})

const actualConfig = config.Z || config;

// 错误处理
const error = error => {
  // 对请求错误做些什么
  if (error.response) {
    const data = error.response.data
    switch(error.response.status) {
      case 500:
        Message.error('服务器响应异常或服务已停止')
        break;
      case 401:
        const token = localStorage.getItem(actualConfig.ACCESS_TOKEN);
        const tokenTime = localStorage.getItem(actualConfig.ACCESS_TOKEN_TIMEOUT);
        if (!token || !tokenTime || !moment(tokenTime).isAfter(moment())) {
          store.dispatch('Logout').then(() => {
            router.push({ path: '/login', query: { redirect: router.currentRoute.fullPath } })
          })
        }
        Message.error('权限不足，请向管理员申请相关权限，再进行相关操作。');
        break;
      case 404:
        Message.error('链接不存在')
        break;
      case 308:
        Message.error('登录状态失效，请重新登录')
        store.dispatch('Logout').then(() => {
          router.push({ path: '/login', query: { redirect: router.currentRoute.fullPath } })
        })
        break;
      case 309: // 尝试重新登录
          console.log('309', error)
          // if (error.response.msg) location.href = error.response.msg
          break;
      default:
        Message.error(data && data.message ? data.message : '请求失败，请刷新浏览器重试')
        break;
    }
  }
  return Promise.reject(error)
}
// 添加请求拦截器
service.interceptors.request.use(
	conf => { // 在发送请求之前做些什么
    const token = localStorage.getItem(actualConfig.ACCESS_TOKEN)
    const language = localStorage.getItem(actualConfig.defaultLocale)
    const companyId = store.getters.companyId
    // console.log('store.getters.companyId', store, store.getters, store.getters.companyId);
    if (token) {
      conf.headers['Authorization'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
    }
    if (language) {
      conf.headers[actualConfig.LANGUAGE] = language // 让每个请求携带自定义 language
    }
    if (companyId) {
      conf.headers['companyId'] = companyId // 让每个请求携带自定义 companyId
    }
		return conf
	},
  error
)

// 添加响应拦截器 2xx 范围内的状态码都会触发该函数
service.interceptors.response.use(
	response => {// 对响应数据做点什么
    if (response.status == 200 && response.data.code === 401) {
      if (response.config.url !== '/sys/logout') {
        Message.error(response.data.msg)
        store.dispatch('Logout').then(() => {
          router.push({ path: '/login', query: { redirect: router.currentRoute.fullPath } })
        })
      }
    } else if (response.status == 200 && response.data.code && response.data.code === 309) {
      console.log('ajax309', response)
      Message.error(response.data.msg)
      store.dispatch('Logout').then(() => {
        router.push({ path: '/login', query: { redirect: router.currentRoute.fullPath } })
      })
      // if (response.data.msg) location.href = response.data.msg
    } else if (response.status == 200 && response.data.code && response.data.code !== 200) {
        Message.error(response.data.msg)
    }
		return response.data
	},
  error
)

export default service

